import { createAction, createRequestTypes, createRequestActions } from './utils';
import keyMirror from 'react-utils/keyMirror';
export const AvatarActionTypes = keyMirror({
  UPLOAD_AVATAR: null,
  REMOVE_AVATAR: null,
  SET_GRAVATAR: null,
  UPDATE_AVATAR: null
});
export const UploadAvatarActionTypes = createRequestTypes(AvatarActionTypes.UPLOAD_AVATAR);
export const UploadAvatar = createRequestActions(UploadAvatarActionTypes);
export const uploadAvatar = blob => createAction(AvatarActionTypes.UPLOAD_AVATAR, {
  data: {
    blob
  }
});
export const RemoveAvatarActionTypes = createRequestTypes(AvatarActionTypes.REMOVE_AVATAR);
export const RemoveAvatar = createRequestActions(RemoveAvatarActionTypes);
export const removeAvatar = () => createAction(AvatarActionTypes.REMOVE_AVATAR);
export const SetGravatarActionTypes = createRequestTypes(AvatarActionTypes.SET_GRAVATAR);
export const SetGravatar = createRequestActions(SetGravatarActionTypes);
export const setGravatar = () => createAction(AvatarActionTypes.SET_GRAVATAR);
export const updateAvatar = updatedAt => createAction(AvatarActionTypes.UPDATE_AVATAR, {
  data: {
    updatedAt
  }
});